import { DailyReport, FullReportEntry, ReportEntry, DayInfo } from "../models/FullReportEntry"
import { load } from "./basic-loader"
import { sum } from 'simple-utils'
import { parseDate } from "simple-utils/dist/date-utils"
 
export async function loadReports(period:string = null, googleMode = false, customGoal = false){
    const result = (await load((googleMode ? "api/v1/google-full-report?" : "api/v1/full-report?") + (period || ""), customGoal ? {"custom-goal-mode": "on"} : {})) as FullReportEntry[]
    result.forEach(e => {
        e.todayLeads = todayLeads(e);
        e.todayCost = todayCost(e);
        e.changeStatusToday = changeStatusToday(e);
        e.dailyReports = buildDailyReports(e);
    });

    result.forEach(e => {
        if(e.past){
            e.past.dailyReports = buildDailyReports(e.past);
            e.past.missingDays = getMissingDays(e.past);
        }
    });

    result.forEach(e => {
        e.lastDate = getLastDate(e)
        e.missingDays = getMissingDays(e);
        e.pastMonthSameDay = getSameDayInfo(e);
        e.pastMonthYesterDayInfo = getPastMonthYesterdayInfo(e);
        e.yesterDayInfo = getYesterdayInfo(e);
    });
    return result;
}

function pad(n:number){
    if(n< 10) return "0" + n;
    return n;
}

function dateToStr(d:Date){
    return `${pad(d.getFullYear())}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
}

function todayLeads(account:ReportEntry){
    if(!account.dateList || !account.dateList.length) return 0;
    var dates = account.dateList.split(/,/);
    var date = dates[dates.length - 1];
    if(date != dateToStr(new Date())) return 0;
    var leads = account.leadsList.split(/,/);
    return parseInt(leads[leads.length - 1]) || 0;
}

function todayCost(account:ReportEntry){
    if(!account.dateList || !account.dateList.length) return 0;
    var dates = account.dateList.split(/,/);
    var date = dates[dates.length - 1];
    if(date != dateToStr(new Date())) return 0;
    var costs = account.costList.split(/,/);
    return parseFloat(costs[costs.length - 1]) || 0;
}

function changeStatusToday(account:FullReportEntry){
    return account.slDate == dateToStr(new Date());
}

export function buildDailyReports(account:ReportEntry):DailyReport[]{
    var result:DailyReport[] = [];
    if(account.dateList == "") 
        return result;
    var dates = account.dateList.split(/,/);
    var leads = account.leadsList.split(/,/);
    var cost = account.costList.split(/,/);
    var clicks = account.clickList.split(/,/);
    
    for(var i in dates){
        result.push({
            date: parseDate(dates[i]),
            cost: parseFloat(cost[i]),
            leads:  parseInt(leads[i]),
            clicks: parseInt(clicks[i])
        })
    }

   

    return result;
}

function getLastDate(e:FullReportEntry):Date{
    var result = e.past ? [...e.past.dailyReports, ... e.dailyReports] : e.dailyReports;
    result = result.filter(i => i.cost > 0);
    if(!result.length) return null
    return result[result.length - 1].date;
}

function getMissingDays(e:ReportEntry):number{
    var days =  e.dailyReports.filter(e => e.cost > 0);
    var result = e.nDays - days.length;
    if(result < 0) return 0;
    return result;
}

function getSameDayInfo(e:FullReportEntry):DayInfo{
    if(!e.past?.dailyReports)
        return {cost: 0, leads: 0};
    
    const days =  e.past.dailyReports.filter(i => i.date.getDate() <= e.nDays);
    const cost = sum(days, e => e.cost)
    const leads = sum(days, e => e.leads)
    
    return {cost, leads};
}

function getYesterdayInfo(e:FullReportEntry):DayInfo{
    if(e.nDays == 1)
        return {cost: 0, leads: 0};
    
    const days =  e.dailyReports.filter(i => i.date.getDate() < e.nDays);
    const cost = sum(days, e => e.cost)
    const leads = sum(days, e => e.leads)
    
    return {cost, leads};
}

function getPastMonthYesterdayInfo(e:FullReportEntry):DayInfo{
    if(!e.past?.dailyReports)
        return {cost: 0, leads: 0};
    
    const days =  e.past.dailyReports.filter(i => i.date.getDate() < e.nDays);
    const cost = sum(days, e => e.cost)
    const leads = sum(days, e => e.leads)
    
    return {cost, leads};
}



